import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'HotWord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'HotWord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'HotWord',
    column_type: 'datetime',
  },
  name: {
    model_name: 'HotWord',
    column_type: 'string',
  },
  position: {
    model_name: 'HotWord',
    column_type: 'string',
  },
  application: {
    model_name: 'HotWord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'application',
      model_name: 'Application',
    },
  },
  application_id: {
    model_name: 'HotWord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'application',
      model_name: 'Application',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
